module.exports = __webpack_public_path__ + "static/media/m_eyebrowshape_upward.03019a53.png";